import { render, staticRenderFns } from "./ProgressLoading.vue?vue&type=template&id=38504744&scoped=true&lang=pug"
import script from "./ProgressLoading.vue?vue&type=script&lang=ts"
export * from "./ProgressLoading.vue?vue&type=script&lang=ts"
import style0 from "./ProgressLoading.vue?vue&type=style&index=0&id=38504744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38504744",
  null
  
)

export default component.exports